export const company = {
    brand: 'VitaeAI',
    legalName: '杭州维态人工智能科技有限公司',
    icp: '浙ICP备2026020819号',
    email: 'vitaeai@qq.com'
}